import styled from "../../theme";
import Box from "./box";

/**
 * @deprecated Use native HTML elements with tailwind classes
 */
export const Flex = styled(Box)`
  display: flex;
`;

Flex.displayName = "Flex";

export default Flex;
